import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  OnDestroy,
} from "@angular/core";
import { IndividualmanagementService } from "../services/individualmanagement.service";
import { ResponseModel } from "src/app/common/models/ResponseModel";
import { FamilyMember } from "src/app/common/models/FamilyMember";
import { ParentCommunicatorService } from "src/app/services/parent-communicator.service";
import { ParentMessageType } from "src/app/common/models/ParentMessage";
import { RootMember } from "src/app/common/models/RootMember";
import { FamilyViewModel } from "src/app/common/models/FamilyViewModel";
import { TreeEditorApiService } from "src/app/components/treeeditor/services/treeeditorapi.service";
import { CreatedIndividual } from "src/app/common/models/CreatedIndividual";
import { CustomError } from "src/app/common/helpers/custom-error";
import { IndividualApiService } from "../../../../services/API/individual-api.service";

@Component({
    selector: "app-individualbasicinfo",
    templateUrl: "./individualbasicinfo.component.html",
    styleUrls: ["./individualbasicinfo.component.scss"],
    standalone: false
})
export class IndividualbasicinfoComponent implements OnInit, OnDestroy {
  isInputFormOpen: boolean = false;
  individualName: string = "";
  selectedMemberData: FamilyMember;
  isErrorMessage: boolean = false;
  errorMessage: string;
  inputBoxTitle: string = "";
  relatiopnShipData: object;
  titleRelationshipOf: string = "";
  titleMainPerson: string = "";
  titleAndPartner: string = "";
  titleAndPartnerShow: boolean = false;
  rootMemberData: any;
  memberDisplayIndex: number;

  @Output() inputFormStatus = new EventEmitter<boolean>();

  //Style changes when error occurs
  okayButton: string = "btn-ok.png";
  closeButton: string = "btn-cancel.png";

  constructor(
    private individualmanagementService: IndividualmanagementService,
    private individualApiService: IndividualApiService,
    private parentCommunicatorService: ParentCommunicatorService,
    private treeEditorApiService: TreeEditorApiService
  ) { }

  ngOnInit(): void {
    this.individualmanagementService.openInputBox.subscribe(
      (data: RelatiopnShipData) => {
        this.rootMemberData = data.rootMemberData;
        this.selectedMemberData = this.initiateAddMemberData(data);
        this.memberDisplayIndex = data.memberData["displayIndex"];
        this.openCloseInputForm();
        this.showHeader(this.selectedMemberData, data.memberData);
      },
      (err) => {
        throw new CustomError(
          "IndividualbasicinfoComponent => ngOnInit() : " + err,
          911,
          false
        );
      }
    );
  }
  openCloseInputFormClick(event: any) {
    if (
      event.target.id == "mainBlackBg" ||
      event.target.className == "closeButton"
    ) {
      this.openCloseInputForm();
    }
  }

  openCloseInputForm() {
    this.isInputFormOpen = !this.isInputFormOpen;
    this.inputFormStatus.emit(this.isInputFormOpen);
    this.individualName = "";
  }

  initiateAddMemberData(data): FamilyMember {
    let gender;
    let relationshipType;

    if (data.relationshiptype && isNaN(data.relationshiptype)) {
      relationshipType = data.relationshiptype;
      //Add siblings or children
      if (relationshipType == "Sister" || relationshipType == "Daughter") {
        gender = "F";
      }
      if (relationshipType == "Brother" || relationshipType == "Son") {
        gender = "M";
      }

      if (data.memberData.gender) {
        //Add spouse
        if (relationshipType == "Spouse" && data.memberData.gender == "M") {
          gender = "F";
        }
        if (relationshipType == "Spouse" && data.memberData.gender == "F") {
          gender = "M";
        }
        if (relationshipType == "Spouse" && data.memberData.gender == "U") {
          gender = "U";
        }
      }
    } else {
      // Add parents;
      if (data.relationshiptype % 2 == 0) {
        gender = "F";
        relationshipType = "Mother";
      } else {
        gender = "M";
        relationshipType = "Father";
      }
    }

    let selectedMemberData = new FamilyMember();
    selectedMemberData.MemberId =
      data.memberData.id > 0 ? data.memberData.id : data.memberData.childId;
    selectedMemberData.RelationShipType = relationshipType;
    selectedMemberData.Gender = gender;
    selectedMemberData.MemberName = "";
    return selectedMemberData;
  }

  private showHeader(newMember, keyMember) {
    this.titleRelationshipOf = newMember.RelationShipType;
    this.titleMainPerson = keyMember.firstName;
    this.titleAndPartner = "";
    this.titleAndPartnerShow = false;

    if (
      newMember.RelationShipType === "Mother" ||
      newMember.RelationShipType === "Father"
    ) {
      this.individualApiService
        .getFamilyMemberDetail(1, true) // , keyMember.childId
        .subscribe((response: ResponseModel<FamilyViewModel>) => {
          if (response.data.individual)
            this.titleMainPerson = response.data.individual.displayName;
        }),
        (err) => {
          throw new CustomError(
            "IndividualbasicinfoComponent => ShowHeader() : " + err,
            911,
            false
          );
        };
    }

    if (newMember.RelationShipType == "Spouse") {
      if (newMember.Gender == "F") {
        this.titleRelationshipOf = "Wife";
      } else this.titleRelationshipOf = "Husband";
    }

    if (
      newMember.RelationShipType == "Daughter" ||
      newMember.RelationShipType == "Son"
    ) {
      this.individualApiService
        .getFamilyMemberDetail(1, true) // , keyMember.id
        .subscribe((response: ResponseModel<FamilyViewModel>) => {
          if (response.data.spouse.length > 0)
            this.titleAndPartner =
              response.data.spouse[0].individual.displayName;
          if (this.titleAndPartner) this.titleAndPartnerShow = true;
        }),
        (err) => {
          throw new CustomError(
            "IndividualbasicinfoComponent => ShowHeader() : " + err,
            911,
            false
          );
        };
    }
  }

  closeInputBox() {
    this.isInputFormOpen = false;
    this.individualName = "";
  }

  closeErrorBox() {
    this.isErrorMessage = false;
    this.buttonChange();
  }

  submitInputName() {
    //If the individual name is empty
    if (this.individualName == "") {
      this.errorMessage = "name_required";
      this.isErrorMessage = true;
    } else {
      //If the individual name contains any special characters or numbers
      if (
        /[$|#|%|^|*|!|&|@|=|+|-]/.test(this.individualName) ||
        /^[0-9]+$/.test(this.individualName) ||
        /^\d+$/.test(this.individualName)
      ) {
        this.errorMessage = "invalid_name";
        this.isErrorMessage = true;
      } else {
        //If the name is accepted
        this.selectedMemberData.MemberName = this.individualName;
        this.createIndividualFamilyMember(this.selectedMemberData);
      }
    }
    this.buttonChange();
  }

  //Change ok cancel button accoring to validation or errors
  buttonChange() {
    if (this.isErrorMessage) {
      this.okayButton = "btn-ok-disable.png";
      this.closeButton = "btn-cancel-disable.png";
    } else {
      this.okayButton = "btn-ok.png";
      this.closeButton = "btn-cancel.png";
    }
  }
  refreshPage() {
    var rootMember = new RootMember();
    rootMember.Id = this.rootMemberData.id;
    rootMember.FirstName = this.rootMemberData.firstName;
    rootMember.LastName = this.rootMemberData.lastName;
    rootMember.DisplayName = this.rootMemberData.displayName
      ? this.rootMemberData.displayName
      : this.rootMemberData.firstName + " " + this.rootMemberData.lastName;
    rootMember.Gender = this.rootMemberData.gender;
    this.parentCommunicatorService.send(
      ParentMessageType.RootMemberChanged,
      rootMember
    );
  }

  createIndividualFamilyMember(memberDetail) {
    this.individualmanagementService
      .createIndividualFamilyMember(memberDetail)
      .subscribe(
        (response: ResponseModel<FamilyMember>) => {
          let createdIndividual = new CreatedIndividual();
          createdIndividual.familyMemberObj = response;
          createdIndividual.relationshipType =
            this.selectedMemberData.RelationShipType;
          createdIndividual.isRootMember =
            this.selectedMemberData.MemberId === this.rootMemberData.id;
          this.individualmanagementService.sendMessage(createdIndividual);
          this.openCloseInputForm();
          this.individualName = "";
        },
        (err) => {
          // FTWebCore answers an unknown member or family with a 404 (FT-1312; it was a 400) and a blank name with a 400.
          if ((err.status === 400 || err.status === 404) && err.error?.errors?.length > 0) {
            this.isErrorMessage = true;
            this.errorMessage = err.error.errors[0] as string;
          } else
            throw new CustomError(
              "IndividualbasicinfoComponent => createIndividualFamilyMember()",
              911,
              false
            );
        }
      )
      .add(() => {
        //self.refreshPage()
      });
  }

  //ToDo: remove this method
  getDisplayIndex(childDisplayIndex: number, increment: number) {
    let divideby = 10;
    let newIndex =
      parseInt(childDisplayIndex.toString()) +
      1 +
      (((childDisplayIndex * 100) % 100) * 2) / 10 / divideby +
      increment / divideby;
    return newIndex.toFixed(2);
  }

  ngOnDestroy() {
    // this.individualmanagementService.openInputBox.unsubscribe();
  }
}

export class RelatiopnShipData {
  relationshiptype: string;
  rootMemberData: object;
  memberData: object;
}
